import styled from "styled-components";
import { screenSizes } from "../../../../utils/constans/styles/screenSizes";

export const FlightDrawerPhotosAndContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;

 @media (min-width: ${screenSizes.mobile + 1}px) and (max-width: 1008px) { {
    flex-direction: column;
    align-items: center;
  }
`;

export const FlightDrawerContentWrapper = styled.div`
  width: 380px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin-bottom: 43px;
`;